window.addEventListener('DOMContentLoaded', (e) => {
  // On certain sections under "field_sections" field, we want the "fade up" to occur.
  const elements = [
    // Home page and some general use cases
    // document.querySelectorAll('.fields-field--field-sections .paragraph--type--two-column-image-text'),
    // document.querySelectorAll('.fields-field--field-sections .paragraph--type--text'),
    // [document.getElementById('block-simpleinstagramfeed')],
    // document.querySelectorAll('.paragraph--type--featured-view.two-column-overlay'),

    // Homepage Stories Block
    {
      els: document.querySelectorAll('.fields-field--field-sections .view-id--stories.view-display-name--block-1 .views-field-title .field-content'),
      effect: 'slide-up',
    },

    // Stories page
    { // @TODO: Fix this busted selector
      els: document.querySelectorAll('.fields-field--field-section .view-id--stories view-display-name--all-stories-block'),
      effect: 'fade-up',
    },

    // Indiv Story Page
    {
      els: document.querySelectorAll('.bottom-left-right-containers .fields-field--field-left-container-content'),
      effect: 'fade-up',
    },
  ];
  for (let i = 0; i < elements.length; i++) {
    for (let j = 0; j < elements[i].els.length; j++) {
      // Ensure we have a DOM tag, not a textNode
      if (elements[i].els[j] && elements[i].els[j].tagName) {
        elements[i].els[j].setAttribute('data-aos', elements[i].effect);
      }
    }
  }

  // As user scrolls down the page, we refresh periodically to ensure we get all items.
  const refreshPoints = [
    { point: 20, isRefreshed: false },
    { point: 40, isRefreshed: false },
    { point: 60, isRefreshed: false },
    { point: 80, isRefreshed: false },
  ];
  window.addEventListener('scroll', function() {
    for (let i = 0; i < refreshPoints.length; i++) {
      const _docHeight = (document.height !== undefined) ? document.height : document.body.offsetHeight;
      const scrollPsn = (_docHeight * refreshPoints[i].point / 100);
      if (!refreshPoints[i].isRefreshed && window.scrollY > scrollPsn) {
        AOS.refresh();
        refreshPoints[i].isRefreshed = true;
      }
    }
  });

  // Initiallizes the AOS Library used to fade up elements on scroll
  AOS.init({ duration: 2000 });
});

